import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import Card from 'garaje/components/ui/card';
import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

interface ApprovalNeedsReviewSignature {
  Args: {
    invite?: Invite;
    entry?: Entry;
    reviewerName?: string;
    fullName: string;
    canResubmit?: boolean;
  };
}

export default <template>
  <Card data-test-approval-denied class="border-carbon-20 mb-8">
    <h5 class="text-sm font-bold mb-1">
      {{#if @entry}}
        Access denied
      {{else if @invite}}
        Invite not approved
      {{/if}}
    </h5>
    <p class="text-sm mb-0" data-private>
      {{#if @entry}}
        {{@fullName}}
        was denied access by
        {{or @reviewerName "an Administrator"}}.
      {{else if @invite}}
        {{@fullName}}'s invitation was denied by
        {{or @reviewerName "an Administrator"}}.
        {{#if @canResubmit}}
          Please update the record and save to resubmit, create a new invite, or contact
        {{else}}
          Please submit a new invite or contact
        {{/if}}
        {{or @reviewerName "an Administrator"}}
        to learn more.
      {{/if}}
    </p>
  </Card>
</template> satisfies TOC<ApprovalNeedsReviewSignature>;
